module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Bold2.0bfc2434.woff";